<script>
import {useEnquiryStore} from "@/store/enquiryStore";
import {storeToRefs} from "pinia";
import EnquiryDetails from "@/components/molecules/enquiry-details/ed-molecule-enquiry-details.vue";
import CardBlock from "@/components/organisms/card-block/ed-organism-card-block.vue";
import { useFeedbackStore } from "@/store/feedbackStore";

export default {
  name: "EnquiryListLarge",
  components: {CardBlock, EnquiryDetails},
  setup() {
    const enquiryStore = useEnquiryStore();
    const {getEnquiries} = storeToRefs(enquiryStore);
    const feedbackStore = useFeedbackStore();

    enquiryStore.fetchEnquiries();
    feedbackStore.fetchEnquiryFeedbackAnswers();

    return {getEnquiries};
  }
}
</script>

<template>
  <div class="col-12 d-flex flex-column">
    <card-block v-for="enquiry in getEnquiries()" :key="enquiry.quoteCode" arrow="center">
      <enquiry-details :enquiry="enquiry" />
    </card-block>
  </div>
</template>

<style scoped>

</style>
